<!--  -->
<template>
  <div style="padding: 20px;">
    <div>
      <el-select v-model="parmrs.department_id" filterable placeholder="请选择部门" @change="newqwr">
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <el-select v-model="parmrs.pitcher_id" :disabled="parmrs.department_id==''" filterable placeholder="请选择投手" style="margin-left: 20px;">
        <el-option
          v-for="item in optionstwo"
          :key="item.id"
          :label="item.admin_name"
          :value="item.id"
        />
      </el-select>
      <el-input v-model="parmrs.account_name" style="width: 300px;margin-left: 20px;" placeholder="请输入广告主名称" />
      <el-input v-model="parmrs.account_id" style="width: 300px;margin-left: 20px;" placeholder="请输入广告主ID" />
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        style="width: 300px;margin-left: 20px;"
        @change="handleDateChange"
      />
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left: 20px;"
        @click="search"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh-left"
        @click="reset"
      >重置</el-button>
    </div>
    <div>
      <el-table
        :data="tableData"
        border
        stripe
        style="width: 100%;margin-top: 20px;"
        @sort-change="sortChange"
      >
        <el-table-column prop="cost_date" label="日期" width="120" align="center" />
        <el-table-column prop="account_id" label="广告主ID" width="130" align="center" />
        <el-table-column prop="account_name" label="广告主名称" width="150" align="center" />
        <el-table-column prop="pitcher_name" label="投手名称" width="120" align="center" />
        <el-table-column prop="department_name" label="部门名称" width="120" align="center" />

        <el-table-column prop="cost" sortable width="130" label="消耗" align="center" />
        <el-table-column prop="click_cost" sortable width="130" label="点击消耗" align="center" />
        <el-table-column prop="active_num" sortable width="130" label="激活数量" align="center" />
        <el-table-column prop="active_cost" sortable width="130" label="激活消耗" align="center" />

        <el-table-column prop="income_0d" sortable width="130" label="首日回收" align="center" />
        <el-table-column prop="income_3d" sortable width="130" label="前3日回收" align="center" />
        <el-table-column prop="income_7d" sortable width="130" label="前7日回收" align="center" />
        <el-table-column prop="rebate_income_0d" sortable width="130" label="首日扣点回收" align="center" />
        <el-table-column prop="rebate_income_3d" sortable width="140" label="前3日扣点回收" align="center" />
        <el-table-column prop="rebate_income_7d" sortable width="140" label="前7日扣点回收" align="center" />

        <el-table-column prop="profit" sortable width="130" label="利润" align="center" />
        <el-table-column prop="rebate_profit" sortable width="130" label="扣点利润" align="center" />
        <el-table-column prop="roi" sortable width="130" label="ROI" align="center" />
        <el-table-column prop="rebate_roi" sortable width="130" label="扣点ROI" align="center" />

        <el-table-column prop="key_behavioural_cnt" sortable width="130" label="关键行为数" align="center" />
        <el-table-column prop="key_behavioural_cost" sortable width="130" label="关键行为成本" align="center" />
        <el-table-column prop="key_behavioural_rate" sortable label="关键行为率" align="center" />
      </el-table>
      <pagination-right
        :current-page="parmrs.page"
        :page-sizes="[10]"
        :total="total"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import { iaaMaterialReportdepartmentlist, iaapitcherindex, reportrecyclingList } from '@/api/TKreleaseGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      options: [],
      optionstwo: [],
      parmrs: {
        page: 1,
        page_size: 10,
        department_id: '',
        pitcher_id: '',
        account_id: '',
        account_name: '',
        start_time: '',
        end_time: ''
      },
      dateRange: [],
      tableData: [],
      total: null,
      order_by: {} // 表格数据排序
    }
  },
  created() {
    this.list()
    this.getlist()
  },
  mounted() {

  },
  methods: {
    list() {
      iaaMaterialReportdepartmentlist({ page: 1, page_size: 100 }).then((res) => {
        this.options = res.data.list
      })
    },
    newqwr() {
      iaapitcherindex({ page: 1, page_size: 100, department_id: this.parmrs.department_id }).then((res) => {
        this.parmrs.pitcher_id = ''
        this.optionstwo = []
        this.optionstwo = res.data.list
      })
    },
    handleDateChange(val) {
      if (val && val.length === 2) {
        this.parmrs.start_time = val[0]
        this.parmrs.end_time = val[1]
      } else {
        this.parmrs.start_time = ''
        this.parmrs.end_time = ''
      }
      console.log('开始时间:', this.start_time, '结束时间:', this.end_time)
    },
    search() {
      this.parmrs.page = 1
      this.getlist()
    },
    reset() {
      this.parmrs = {
        page: 1,
        page_size: 10,
        department_id: '',
        pitcher_id: '',
        account_id: '',
        account_name: '',
        start_time: '',
        end_time: ''
      }
      this.dateRange = []
      this.getlist()
    },
    getlist() {
      reportrecyclingList({ ...this.parmrs, order_by: this.order_by && this.order_by.field && this.order_by.order ? this.order_by : null }).then((res) => {
        console.log(res)
        this.tableData = res.data.list
        this.total = res.data.count
      })
    },
    // 分页
    fetchPageSize(e) {
      this.parmrs.page_size = e
      this.getlist()
    },
    fetchCurrentPage(e) {
      this.parmrs.page = e
      this.getlist()
    },
    // 列表排序
    sortChange(cell) {
      console.log('cell:', cell)
      this.order_by['order'] = !cell.order ? cell.order : cell.order === 'ascending' ? 'asc' : 'desc'
      // this.order_by['field'] = !cell.order ? cell.order : 'cost'
      this.order_by['field'] = !cell.order
        ? cell.order : cell.prop
      this.getlist()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
